import React from 'react';
import SafeIcon from '../../../common/SafeIcon';
import { FiBookOpen, FiUsers, FiCalendar, FiBell, FiTag } from 'react-icons/fi';
import { trainingModules } from '../../../data/trainingModules';

const Row = ({ icon, label, value }) => (
  <div className="flex items-start gap-3 py-3 border-b border-slate-100 last:border-0">
    <SafeIcon icon={icon} className="text-slate-400 flex-shrink-0 mt-0.5" />
    <div>
      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{label}</p>
      <p className="text-sm text-slate-800 font-medium mt-0.5">{value}</p>
    </div>
  </div>
);

const StepReview = ({ form, employees = [] }) => {
  const selectedModules = trainingModules.filter(m => form.trainingContent.includes(m.id));
  const selectedLearners = employees.filter(l => form.individualLearners.includes(l.id));

  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 rounded-xl px-4 py-3">
        <p className="text-sm font-semibold text-blue-700 mb-0.5">Review your campaign</p>
        <p className="text-xs text-blue-600">Please confirm all settings before creating.</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl px-4 divide-y divide-slate-100">
        <Row icon={FiTag} label="Campaign Name" value={form.campaignName} />
        <Row icon={FiTag} label="Type" value={form.campaignType} />
        <Row icon={FiUsers} label="Audience"
          value={selectedLearners.length > 0 ? selectedLearners.map(l => `${l.firstName} ${l.lastName}`).join(', ') : form.departments.join(', ') || 'All Employees'} />
        <Row icon={FiBookOpen} label="Training Modules"
          value={selectedModules.length > 0 ? selectedModules.map(m => m.title).join(', ') : 'None selected'} />
        <Row icon={FiCalendar} label="Schedule"
          value={form.startDate && form.endDate ? `${form.startDate} → ${form.endDate}` : 'Not set'} />
        <Row icon={FiBell} label="Reminders"
          value={form.reminderEnabled ? `${form.reminderDays.join(', ')} days before due date` : 'Disabled'} />
      </div>
    </div>
  );
};

export default StepReview;